// extracted by mini-css-extract-plugin
export default {"tupacGrid":"wo-z","tupacHeader":"xo-z","tupacHeader2":"yo-z","tupacMenu":"zo-z","tupacMenu2":"Ao-z","tupacMain":"Bo-z","tupacMain2":"Co-z"};